/*
 *
 * OrderTreatment reducer
 *
 */

import { fromJS } from "immutable";
import * as CONSTANTS from "./constants";
export const initialState = fromJS({
  loading: false,
  error: "",
  dentists: [],
  insurers: [],
  patient: {},
  productPlan: {},
  activeOrderId: 0,
  canContinue: false,
});

function orderTreatmentReducer(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.DELETE_ORDER_SUCCESS:
      return state.set("productPlan", action.data).set("activeOrderId", null);

    case CONSTANTS.CREATE_PRODUCT_PLAN_ERROR:
    case CONSTANTS.UPDATE_PRODUCT_PLAN_ERROR:
    case CONSTANTS.GET_ACTIVE_PRODUCT_PLAN_ERROR:
      return state.set("loading", false).set("productPlan", {});

    case CONSTANTS.GET_ACTIVE_PRODUCT_PLAN_SUCCESS:
      return state.set("loading", false).set("productPlan", action.productPlan);

    case CONSTANTS.UPDATE_PRODUCT_PLAN_SUCCESS:
    case CONSTANTS.CREATE_PRODUCT_PLAN_SUCCESS:
      return state
        .set("loading", false)
        .set("productPlan", action.productPlan)
        .set("canContinue", true);

    case CONSTANTS.GET_PATIENT:
    case CONSTANTS.GET_ACTIVE_PRODUCT_PLAN:
      return state.set("loading", true).set("error", "");

    case CONSTANTS.GET_DENTISTS:
    case CONSTANTS.GET_INSURERS:
    case CONSTANTS.CREATE_PRODUCT_PLAN:
    case CONSTANTS.UPDATE_PRODUCT_PLAN:
      return state.set("error", "");

    case CONSTANTS.GET_DENTISTS_SUCCESS:
      return state.set("loading", false).set("dentists", action.dentists);

    case CONSTANTS.GET_INSURERS_SUCCESS:
      return state.set("loading", false).set("insurers", action.insurers);

    case CONSTANTS.GET_PATIENT_SUCCESS:
      return state.set("loading", false).set("patient", action.patient);

    case CONSTANTS.GET_PATIENT_ERROR:
    case CONSTANTS.GET_INSURERS_ERROR:
    case CONSTANTS.GET_DENTISTS_ERROR:
      return state.set("loading", false).set("error", action.error);

    case CONSTANTS.SET_PRODUCT_PLAN:
      return state.set("productPlan", action.productPlan);

    case CONSTANTS.SET_ACTIVE_ORDER_ID:
      return state.set("activeOrderId", action.orderId);

    case CONSTANTS.RESET:
      return initialState;

    default:
      return state;
  }
}

export default orderTreatmentReducer;
